"use strict";
/**
 * Derived types from const arrays
 */
Object.defineProperty(exports, "__esModule", { value: true });
